export default {
	MENU_OPTIONS: [{
		label: 'home',
		route: '/'
	}, {
		label: 'namSan',
		route: '/master-nam-san'
	}, {
		label: 'taekwondo',

		route: '/taekwondo'
	}, {
		label: 'exams',
		route: '/exams'
	}, {
		label: 'learning',
		route: '/learning'
	}]
}
